import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { formatTL } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const { user } = useAuth();
  const isB2B = user?.role === "b2b_dealer" && user?.b2b_status === "approved";
  const pricing = product.pricing || {};
  const showOriginalCurrency = pricing.currency && pricing.currency !== "TRY";

  return (
    <div data-testid={`product-card-${product.slug}`} className="kz-card group hover:border-ink-900 transition-colors flex flex-col">
      <Link to={`/urun/${product.slug}`} className="block relative bg-ink-100 aspect-square overflow-hidden">
        <img src={product.image_url} alt={product.name} loading="lazy"
             className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"/>
        {isB2B && pricing.discount_percent > 0 && !pricing.special_price && (
          <span className="absolute top-2 left-2 bg-b2b text-white text-[10px] font-bold px-2 py-1">
            BAYİ -%{pricing.discount_percent}
          </span>
        )}
        {pricing.campaign_percent > 0 && (
          <span data-testid={`campaign-badge-${product.slug}`} className="absolute bottom-2 left-2 bg-brand text-white text-[10px] font-bold px-2 py-1">
            KAMPANYA -%{pricing.campaign_percent}
          </span>
        )}
        {pricing.special_price && (
          <span className="absolute top-2 left-2 bg-b2b text-white text-[10px] font-bold px-2 py-1">SİZE ÖZEL FİYAT</span>
        )}
        {product.featured && !isB2B && !pricing.campaign_percent && (
          <span className="absolute top-2 left-2 bg-brand text-white text-[10px] font-bold px-2 py-1">ÖNE ÇIKAN</span>
        )}
        {showOriginalCurrency && (
          <span className="absolute top-2 right-2 bg-white/90 text-ink-900 text-[10px] font-bold px-2 py-1">
            {product.currency}
          </span>
        )}
      </Link>
      <div className="p-4 flex-1 flex flex-col">
        <div className="text-xs text-ink-500 uppercase tracking-wider mb-1">{product.brand || "SGS"}</div>
        <Link to={`/urun/${product.slug}`} className="font-display font-bold text-base leading-tight mb-2 hover:text-brand line-clamp-2 min-h-[2.5rem]">
          {product.name}
        </Link>
        <div className="text-xs text-ink-500 font-mono mb-3">SKU: {product.sku}</div>
        <div className="mt-auto flex items-end justify-between gap-2">
          <div>
            {(pricing.discount_percent > 0 || pricing.campaign_percent > 0) && (
              <div className="text-xs text-ink-500 line-through">{formatTL(pricing.list_price_try * 1.2)}</div>
            )}
            <div className="font-display font-black text-xl text-ink-900">
              {formatTL(pricing.gross_price || 0)}
            </div>
            <div className="text-[10px] text-ink-500">
              {showOriginalCurrency && <>Liste: {pricing.list_price_original ?? product.price} {product.currency} · </>}
              KDV dahil
            </div>
          </div>
          <button
            data-testid={`add-to-cart-${product.slug}`}
            onClick={(e) => { e.preventDefault(); add({ ...product, price: pricing.gross_price || product.price }); toast.success("Sepete eklendi"); }}
            className="bg-ink-900 hover:bg-brand text-white p-2.5 transition-colors"
            aria-label="Sepete ekle"
          >
            <ShoppingCart size={18}/>
          </button>
        </div>
      </div>
    </div>
  );
}
